import UIDs from "../../../../UIDs";

const uid = UIDs.screens.talkchinese.practice;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    REPORT_RESULT: `${uid}.reportResult`,
    NEXT_UNIT: `${uid}.nextUnit`,
    UPDATE_UNIT_RESULT_ASYNC: `${uid}.updateUnitResultAsync`,
    UPDATE_UNIT_RESULT_SUCCESS: `${uid}.updateUnitResultSuccess`,
    UPDATE_UNIT_RESULT_FAILURE: `${uid}.updateUnitResultFailure`,
    REVIEW_UNIT_ASYNC: `${uid}.reviewUnitAsync`,
    REVIEW_UNIT_SUCCESS: `${uid}.reviewUnitSuccess`,
    REVIEW_UNIT_FAILURE: `${uid}.reviewUnitFailure`,
    SHOW_FOOTER: `${uid}.showFooter`,
    SHOW_COMMON_MODAL_REF: `${uid}.showCommonModalRef`,
    UPDATE_SETTINGS: `${uid}.updateSettings`,
    SHOW_PRACTICE_RESULT: `${uid}.showPracticeResult`,
    RESTART_ASYNC: `${uid}.restartAsync`,
    RESTART_ASYNC_SUCCESS: `${uid}.restartAsyncSuccess`,
    RESTART_ASYNC_FAILURE: `${uid}.restartAsyncFailure`,
    COMPLETE_ASYNC: `${uid}.completeAsync`,
    COMPLETE_ASYNC_SUCCESS: `${uid}.completeAsyncSuccess`,
    COMPLETE_ASYNC_FAILURE: `${uid}.completeAsyncFailure`,
    REVIEW_RESTART: `${uid}.reviewRestart`,
};

export { ActionTypes };
